import toString from './to-string';
var lowerFirst = function (value) {
    var str = toString(value);
    return str.charAt(0).toLowerCase() + str.substring(1);
};
export default lowerFirst;
//# sourceMappingURL=lower-first.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/lower-first.js
// module id = 504
// module chunks = 3